import SaasLogger from '../../services/SaasLogger';
import callApi from '../../utils/callApi';


export default class WebRTCPlayer {

  constructor(uri, video, onStarted, onStopped, onPlayError, analyticsInfo) {

    if (!uri) {
      throw new Error('No uri given');
    }

    if (!video) {
      throw new Error('No video element given');
    }
    this.metricsURI = 'https://logger007.cam4.com/log/webRTC/nn/ceeblue/stats/viewer';
    this.signalingURI = uri;
    this.videoElement = video;
    this.analyticsInfo = analyticsInfo;
    this.ws = null;
    this.peerConnection = null;

    this.localOffer = null;

    this.OnStarted = onStarted;
    this.OnStopped = onStopped;
    this.OnPlayError = onPlayError;
    this.statsInterval = null;
  }

  start() {
    SaasLogger.log('WebRTCPlayer start');

    try {
      this.ws = new WebSocket(this.signalingURI);

      this.ws.onopen = () => this._OnEvent({ type: 'on_connected' });

      this.ws.onmessage = (e) => {
        try {
          this._OnEvent(JSON.parse(e.data));
        } catch (e) {
          SaasLogger.error('WebRTCPlayer Failed to parse a response from signalling server', e);
        }
      };

      // See http://tools.ietf.org/html/rfc6455#section-7.4.1
      this.ws.onclose = (ev) => {
        switch (ev.code) {
          default: {
            this._OnEvent({ type: 'on_disconnected' });
            break;
          }
        }
      };

      this.videoElement.autoplay = true;
      this.videoElement.onloadeddata = () => {
        SaasLogger.log('WebRTCPlayer VideoElement on loadeddata');

        this.videoElement.play().catch((e) => {
          this.stop();
          this.OnPlayError(e);
        });
      };

      this.peerConnection = new RTCPeerConnection();

      this.statsInterval = setInterval(() => {
        if (this.peerConnection) {
          this.peerConnection.getStats(null).then((stats) => {
            SaasLogger.log('peeer connection stats response', stats);
            const statsOutput = [];

            stats.forEach((report) => {
              if (['inbound-rtp', 'track', 'transport', 'stream'].includes(report.type)) {
                statsOutput.push(report);
              }
            });
            const analytics = {
              ...this.analyticsInfo,
              domain: window.location.hostname,
              stats: statsOutput,
            };
            callApi(this.metricsURI, 'POST', {}, JSON.stringify(analytics), {}, false, false).then((res) => {
              SaasLogger.log('Metrics sent');
            });

          });
        }
      }, 10000);

      this.peerConnection.ontrack = (ev) => {
        SaasLogger.log('WebRTCPlayer peerConnection.ontrack');
        this.videoElement.srcObject = ev.streams[0];
      };
    } catch (e) {
      SaasLogger.error('WebRTCPlayer Failed to Play stream', e);
    }
  }

  stop() {
    SaasLogger.log('WebRTCPlayer stop');
    if (this.statsInterval) {
      clearInterval(this.statsInterval);
    }
    if (this.ws) {
      this.ws.close();
    }
  }

  _OnEvent(ev) {
    switch (ev.type) {
      case 'on_connected': {
        this._OnConnected();
        break;
      }
      case 'on_disconnected': {
        this._OnDisconnected();
        break;
      }
      case 'on_answer_sdp': {
        this._OnAnswerSDP(ev.answer_sdp);
        break;
      }
      case 'on_seek': {
        this._OnSeek(ev);
        break;
      }
      case 'on_error': {
        this._OnError(ev);
        break;
      }
      case 'on_video_bitrate': {
        this._OnVideoBitrate(ev);
        break;
      }
      case 'on_time': {
        SaasLogger.log(ev);
        break;
      }
      case 'on_stop': {
        this._OnDisconnected();
        break;
      }
      default: {
        SaasLogger.warn('Unhandled event:', ev.type);
        break;
      }
    }
  }

  _OnConnected() {
    SaasLogger.log('WebRTCPlayer OnConnected');

    this.peerConnection.
      createOffer({ offerToReceiveAudio: true, offerToReceiveVideo: true }).
      then(this._OnCreateOfferSuccess.bind(this)).
      catch((e) => SaasLogger.error('WebRTCPlayer Could not create offer', e));
  }

  _OnDisconnected() {
    SaasLogger.log('WebRTCPlayer OnDisconnected');

    if (this.ws) {
      this.ws.close();
    }
    this.ws = null;

    if (this.peerConnection) {
      this.peerConnection.getReceivers().
        forEach((receiver) => receiver.track.stop());

      this.peerConnection.close();
      this.peerConnection = null;
    }

    this.videoElement.srcObject = null;
    this.videoElement.onloadeddata = null;

    if (this.OnStopped) {
      this.OnStopped();
    }
  }

  _OnVideoBitrate(ev) {
    SaasLogger.log('WebRTCPlayer Video bitrate update to:', ev.video_bitrate);
  }

  _OnError(ev) {
    SaasLogger.error(ev.error);
  }

  _OnCreateOfferSuccess(offer) {
    SaasLogger.log('WebRTCPlayer OnCreateOfferSuccess');
    SaasLogger.log(offer.sdp);

    this.localOffer = offer;
    this.peerConnection.
      setLocalDescription(offer).
      then(this._OnSetOfferSuccess.bind(this)).
      catch((e) => SaasLogger.error('WebRTCPlayer Failed to set offer', e));
  }

  _OnSetOfferSuccess() {
    SaasLogger.log('WebRTCPlayer OnSetOfferSuccess');
    SaasLogger.log(JSON.stringify({ type: 'offer_sdp', offer_sdp: this.localOffer.sdp }));
    this.ws.send(JSON.stringify({ type: 'offer_sdp', offer_sdp: this.localOffer.sdp }));
  }

  _OnAnswerSDP(answer_sdp) {
    SaasLogger.log('WebRTCPlayer OnAnswerSDP');
    SaasLogger.log(answer_sdp);

    const answer = { type: 'answer', sdp: answer_sdp };
    this.peerConnection.
      setRemoteDescription(answer).
      then(this._OnSetAnswerSuccess.bind(this)).
      catch((e) => SaasLogger.error('WebRTCPlayer Could not set SDP answer', e));
  }

  _OnSeek(ev) {
    SaasLogger.log('OnSeek');
  }

  _OnSetAnswerSuccess() {
    SaasLogger.log('WebRTCPlayer OnSetAnswerSuccess');

    if (this.OnStarted) {
      this.OnStarted();
    }
  }
}
